import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: calc(100vh - 5rem);
  overflow-y: auto;

  > div {
    margin-bottom: 1rem;
  }

  a {
    color: ${({ theme: { palette } }) => palette.primary};
  }
`;
